module.exports = __webpack_public_path__ + "static/img/ic_general_sale.412a4cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_general_sale.png
// module id = 4Sez
// module chunks = 1